import { useSelector } from "react-redux";
import DataCollectionProcessLogs from "../../../components/DataCollection/Monitoring/Dc_ProcessLogs/DataCollectionProcessLogs";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import Page404 from "../../../components/Page404/Page403";

const DataCollectionProcesLogsScreen = () => {
  const response = useSelector(selectUserData);
  const hasMonitoringProcessLogsViewPermission = CheckPermissions(
    response?.data?.products?.data_collection,
    "monitoring",
    "view_workflows"
  );

  return (
    <>
      {hasMonitoringProcessLogsViewPermission ? (
        <DataCollectionProcessLogs />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default DataCollectionProcesLogsScreen;
